import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DownOutlinedIcon } from 'assets/icons';
import { TireSet } from 'domains/tires/Tire.types';
import {
  BrandMenuItem,
  DropdownMenu,
  SAntDropdown,
} from 'pages/TiresPage/TireSearch/TiresSearchbar/TiresSearchbar.styled';
import { Checkbox, Flex, Icon, MarginBox, Text } from 'UI';

const TireSetSelection = ({
  tireSet,
  setTireSet,
  'data-cy': dataCy,
}: {
  tireSet: TireSet | undefined;
  setTireSet: (tireSet: TireSet | undefined) => void;
  'data-cy'?: string;
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const getLabel = () => {
    const setString = tireSet ? `(${tireSet})` : '';
    return <>{t('catalog.tires.set_param', 'Set {{set}}', { set: setString })}</>;
  };

  const setArray: TireSet[] = [2, 4, 6, 8];

  const tireSetMenu = (
    <DropdownMenu type={'season'} translateY={0} translateX={0} data-cy={'tires-set-dropdown-open'}>
      <Flex direction={'column'}>
        {setArray.map((setNum) => {
          return (
            <Flex key={setNum} direction={'row'} align={'center'}>
              <MarginBox mr={10}>
                <Checkbox
                  checked={tireSet === setNum}
                  onChange={() => setTireSet(tireSet === setNum ? undefined : setNum)}
                />
              </MarginBox>
              <BrandMenuItem
                onClick={() => setTireSet(tireSet === setNum ? undefined : setNum)}
                data-cy={`tires-set-${setNum}`}
              >
                <Text type="base" color="grey35">{`Set ${setNum}`}</Text>
              </BrandMenuItem>
            </Flex>
          );
        })}
      </Flex>
    </DropdownMenu>
  );

  return (
    <SAntDropdown
      overlay={tireSetMenu}
      trigger={['click']}
      visible={open}
      onVisibleChange={(visible) => setOpen(visible)}
      bordered
    >
      <button className="ant-dropdown-link" data-cy={dataCy}>
        <MarginBox mr={12} />
        <Text type="lg" color="grey35">
          {getLabel()}
        </Text>
        <Flex direction={'row-reverse'}>
          <Icon IconComponent={DownOutlinedIcon} size={18} color={'black'} />
        </Flex>
        <MarginBox mx={5} />
      </button>
    </SAntDropdown>
  );
};

export default TireSetSelection;
